import React from 'react';
import { SVGProps } from './type';

const Icon = ({ fill }: SVGProps) => (
  <g>
    <path
      d="M13.5 10.5H19.5C20.3284 10.5 21 11.1716 21 12C21 12.8284 20.3284 13.5 19.5 13.5H13.5C13.5 13.5 13.6754 13.5 13 13.5C12.3246 13.5 12.8284 13.5 12 13.5C11.1716 13.5 11.3319 13.5 11 13.5C10.6681 13.5 10.5 13.5 10.5 13.5H4.5C3.67157 13.5 3 12.8284 3 12C3 11.1716 3.67157 10.5 4.5 10.5H10.5C10.5 10.5 10.1591 10.5 11 10.5C11.8409 10.5 11.1716 10.5 12 10.5C12.8284 10.5 12.4938 10.5 13 10.5C13.5062 10.5 13.5 10.5 13.5 10.5Z"
      fill={fill}
    />
  </g>
);

export default Icon;
